import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DowntimeService } from '../services/downtime/downtime.service';
import { FeatureToggleService } from '../services/feature-toggle/feature-toggle.service';
import { Feature } from '../model/features.enum';
import { AppRoutes } from '../routes/common.routes';

export const downtimeGuard: CanActivateFn = (): Promise<boolean> => {
  const downtimeService = inject(DowntimeService);
  const featureToggle = inject(FeatureToggleService);
  const router = inject(Router);

  if (!featureToggle.when(Feature.DowntimeRedirect)()) {
    return Promise.resolve(true);
  }
  return downtimeService.getDowntimeStatus().then((downtime) => {
    if (downtime) {
      router.navigate([AppRoutes.downtime]);
      return false;
    }
    return true;
  });
};
